import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fff9f3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "caseView"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0);",
  class: "back-link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "df jc-right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon icon-share" }),
    /*#__PURE__*/_createElementVNode("span", { class: "icon icon-dots" })
  ])
], -1))
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "subpages" }
const _hoisted_6 = {
  key: 1,
  class: "d-caseView"
}
const _hoisted_7 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_drive_photo_carousel = _resolveComponent("drive-photo-carousel")!
  const _component_drive_overview = _resolveComponent("drive-overview")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, {
          "custom-title": _ctx.title,
          countPadding: ""
        }, {
          "top-left": _withCtx(() => [
            _hoisted_2
          ]),
          "top-right": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["custom-title"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_drive_photo_carousel, {
            skeleton: "",
            photoSkeletons: _ctx.photoSkeletons
          }, null, 8, ["photoSkeletons"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_drive_overview, {
              skeleton: "",
              fileSkeletons: _ctx.fileSkeletons
            }, null, 8, ["fileSkeletons"])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_app_loader)
        ])
      ]))
}